/*!*
 * @author yueheqin
 * @date 2019/7/1
 * @project zujuanzaixian
 * @desc
 */
export const identifyCodeMixin = {
  data () {
    const validateIdentifyCode = (rule, value, callback) => {
      if (value !== this.identifyCode) {
        callback(new Error('验证码输入错误!'))
      } else {
        callback()
      }
    }
    return {
      identifyCode: '',
      identifyCodes: '1234567890',
      rules: {
        identifyCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' },
          { validator: validateIdentifyCode, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.identifyCode = ''
    this.makeCode(this.identifyCodes, 4)
  },
  methods: {
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    }
  }
}
